import { render } from "./FeaturedCollectionCarouselV2.vue?vue&type=template&id=4384e8ed"
import script from "./FeaturedCollectionCarouselV2.vue?vue&type=script&lang=js"
export * from "./FeaturedCollectionCarouselV2.vue?vue&type=script&lang=js"

import exportComponent from "/home/runner/work/rb-redev/rb-redev/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__